import React from "react";
import {
  FaFont,
  FaImage,
  FaFileAlt,
  FaQuestionCircle,
  FaUsers,
  FaPoll,
  FaTrophy,
} from "react-icons/fa";
import "./PostTypeSelector.css";

const PostTypeSelector = ({ selectedType, onSelectType }) => {
  const types = [
    { id: "text", label: "Text", icon: FaFont },
    { id: "photo", label: "Photo", icon: FaImage },
    { id: "research", label: "Research", icon: FaFileAlt },
    { id: "question", label: "Question", icon: FaQuestionCircle },
    { id: "collaboration", label: "Collaboration", icon: FaUsers },
    { id: "poll", label: "Poll", icon: FaPoll },
    { id: "milestone", label: "Milestone", icon: FaTrophy },
  ];

  return (
    <div className="post-type-selector">
      {types.map((type) => {
        const Icon = type.icon;
        return (
          <button
            key={type.id}
            className={`type-tab ${selectedType === type.id ? "active" : ""}`}
            onClick={() => onSelectType(type.id)}
            title={type.label}
            aria-label={type.label}
          >
            <Icon />
          </button>
        );
      })}
    </div>
  );
};

export default PostTypeSelector;
